import { ILearning } from "@kunduz/data-access-learning-api";
import { getCoreApiNetworkClient } from "@kunduz/data-access-core-api";
import { useQuery } from "@tanstack/react-query";

export const useSimilarCourses = (options: {
  id?: number;
  type?: string;
}): {
  similarCourses: ILearning.LearningSimilarCourse[];
  similarCoursesLoading: boolean;
  similarCoursesError: any;
} => {
  const apiClient = getCoreApiNetworkClient({});
  const shouldFetch = !!options.id && !!options.type;

  const fetcher = (url) => apiClient.get(url).then((res) => res.data.results);

  const { data, error, isLoading, isRefetching, refetch } = useQuery({
    queryKey: ["similar courses", options],
    queryFn: () =>
      fetcher(`/learning/api/${options.type}/${options.id}/similars/`),
    enabled: shouldFetch,
  });

  return {
    similarCourses: data,
    similarCoursesError: error,
    similarCoursesLoading: isLoading,
  };
};
